import { AdminFaqCreateComponent, AdminFaqEditComponent } from '@app/main/admin/modules/admin-faq/components';
import { AdminFaqComponent } from '@app/main/admin/modules/admin-faq/admin-faq.component';
import { SharedModule } from '@shared/shared.module';
import { AdminFaqListComponent } from '@app/main/admin/modules/admin-faq/components/admin-faq-list/admin-faq-list.component';
import { NgModule } from '@angular/core';

@NgModule({
    declarations: [AdminFaqComponent, AdminFaqCreateComponent, AdminFaqEditComponent, AdminFaqListComponent],
    exports: [AdminFaqComponent],
    imports: [SharedModule]
})
export class AdminFaqModule {}
